import router from "@/lib/router";
import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.pay.templates": "Modèles de bulletins",
			"breadcrumb.pay.slip.templates": "Modèles de pages",
			"breadcrumb.pay.slip.templates.create": "Création",
			"breadcrumb.pay.slip.templates.edit": "Édition",
			"menu.pay.templates": "Modèle de bulletin"
		});

		breadcrumb.add([
			{
				path: "/database/pay-templates",
				name: "home>database>pay.templates"
			},
			{
				path: "/database/pay-templates/([0-9]+)/pages",
				replacePath: "/database/pay-templates/{1}/pages",
				name: "home>database>pay.templates>pay.slip.templates"
			},
			{
				path: "/database/pay-templates/([0-9]+)/pages/create",
				replacePath: "/database/pay-templates/{1}/pages/create",
				name: "home>database>pay.templates>pay.slip.templates>pay.slip.templates.create"
			},
			{
				path: "/database/pay-templates/([0-9]+)/pages/([0-9]+)",
				replacePath: "/database/pay-templates/{1}/pages/{2}",
				name: "home>database>pay.templates>pay.slip.templates>pay.slip.templates.edit"
			}
		]);
		router.addRoutes([
			{
				path: "/database/pay-templates",
				name: "payTemplates",
				component: () => import("./vues/List.vue"),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/pay-templates/:id/pages",
				name: "paySlipTemplates",
				component: () => import("./vues/paySlipTemplates/List.vue"),
				props: route => ({ id: parseInt(route.params.id, 10) }),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/pay-templates/:payTemplateId/pages/create",
				name: "paySlipTemplates.create",
				component: () => import("./vues/paySlipTemplates/AddEdit.vue"),
				props: route => ({ payTemplateId: parseInt(route.params.payTemplateId, 10) }),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/pay-templates/:payTemplateId/pages/:id",
				name: "paySlipTemplates.edit",
				component: () => import("./vues/paySlipTemplates/AddEdit.vue"),
				props: route => ({
					payTemplateId: parseInt(route.params.payTemplateId, 10),
					id: parseInt(route.params.id, 10)
				}),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			}
		]);
	}
};
